<template>
  <div class="application-settings card popup settings-popup popup-right-align shadow">
    <user-badge></user-badge>
    <ul class="list-group list-group-py" style="list-style-type: none">
      <li class="border-bottom">
        <span @click="$emit('close')">
          <router-link
            class="list-group-item list-group-item-action"
            :to="{
              name: 'my-tasks',
              query: {
                back: $route.path
              }
            }">
            {{ $t("myTasks") }}
          </router-link>
        </span>
      </li>
    </ul>
    <ul class="list-group profile-settings-menu interface">
      <li class="list-group-item justify-content-between align-items-center">
        <span class="pr-2">{{ $t("Interface") }}</span>
        <span><locale-switcher /></span>
      </li>
    </ul>
    <language-switcher />
    <ul class="list-group list-group-py" style="list-style-type: none">
      <li class="border-bottom">
        <router-link class="list-group-item list-group-item-action" :to="{ name: 'status' }">
          {{ $t("aboutMedaproEverywhere") }}
        </router-link>
      </li>
      <li class="border-bottom">
        <span @click="$emit('close')">
          <router-link class="list-group-item list-group-item-action" :to="{ name: 'user-settings' }">
            {{ $t("settings") }}
          </router-link>
        </span>
      </li>
      <li>
        <a href="#" class="list-group-item list-group-item-action" @click.prevent="signOff" data-cy="logout-link">
          {{ $t("logOut") }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import LocaleSwitcher from "@common/components/LocaleSwitcher.vue";
import userBadge from "@common/components/UserBadge.vue";
import languageSwitcher from "../LanguageSwitcher.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LocaleSwitcher,
    languageSwitcher,
    userBadge
  },
  computed: {
    ...mapGetters("metadata", ["hasAnyUnsavedData", "hasAnyUploadInProgress"])
  },
  methods: {
    ...mapActions(["logout"]),
    async signOff() {
      if (this.hasAnyUploadInProgress) {
        if (this.hasAnyUnsavedData) {
          if (!confirm(this.$t("confirmNavigationOnUploadAndUnsavedData"))) {
            return;
          }
        } else {
          if (!confirm(this.$t("confirmNavigationOnUpload"))) {
            return;
          }
        }
        // Cancel the upload if any in progress before logout
        await this.$store.dispatch("cancelActionsIfAny");
      } else if (this.hasAnyUnsavedData) {
        if (!confirm(this.$t("confirmNavigation"))) {
          return;
        }
      }
      await this.logout();
      this.$router.push({
        name: "logout",
        query: { go: this.$route.fullPath }
      });
    }
  }
};
</script>
